import { useEffect } from "react";
import { isCrispChatEnabled } from "../../../cores/config/featureFlags";

const CRISP_WEBSITE_ID = "6f22fabe-e85b-4725-ba23-eaf143a0d803";

/** Carga Crisp solo cuando el flag de entorno lo permite (prod: off por defecto). */
export default function CrispChatLoader() {
  useEffect(() => {
    if (!isCrispChatEnabled()) return;

    const w = window as Window & {
      $crisp?: unknown[];
      CRISP_WEBSITE_ID?: string;
      CRISP_RUNTIME_CONFIG?: { locale: string };
    };

    if (!Array.isArray(w.$crisp)) {
      w.CRISP_RUNTIME_CONFIG = { locale: "es" };
      w.$crisp = [];
      w.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
    }

    const existing = document.querySelector('script[src*="client.crisp.chat"]');
    if (existing) return;

    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;
    document.head.appendChild(script);
    document.body.classList.add("crisp-chat-enabled");

    return () => {
      document.body.classList.remove("crisp-chat-enabled");
    };
  }, []);

  return null;
}
